export default __webpack_public_path__ + "static/media/glove_g2.ab0bf527.jpg";